<template>
	<div
		class="g-block-title-slant-tag g-block-title-padding"
		:class="{
			'g-block-title-slant-tag--edit': editable,
			'is-active': editable && active,
			'g-block-title-slant-tag--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-slant-tag__row">
			<div class="g-block-title-slant-tag__tag" :style="{ background: themeColor }">
				<div class="g-block-title-slant-tag__tag-inner">
					<RichTextEditable
						v-if="editable"
						class="g-block-title-slant-tag__text g-block-title-slant-tag__text--tag"
						fit-content
						:model-value="data.primaryText"
						placeholder="标签"
						@update:model-value="onPrimaryUpdate"
						@focus="onWrapClick"
					/>
					<div
						v-else
						class="g-block-title-slant-tag__text g-block-title-slant-tag__text--tag"
						v-html="data.primaryText || ''"
					></div>
				</div>
			</div>
			<RichTextEditable
				v-if="editable"
				class="g-block-title-slant-tag__text g-block-title-slant-tag__text--main"
				fit-content
				:style="{ color: themeColor }"
				:model-value="data.secondaryText"
				placeholder="主标题"
				@update:model-value="onSecondaryUpdate"
				@focus="onWrapClick"
			/>
			<div
				v-else
				class="g-block-title-slant-tag__text g-block-title-slant-tag__text--main"
				:style="{ color: themeColor }"
				v-html="data.secondaryText || ''"
			></div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { dualTitleMixin } from '../shared/dualTitleMixin.js';

	export default {
		name: 'GBlockTitleSlantTag',
		components: { RichTextEditable },
		mixins: [dualTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-slant-tag {
		.title-block-edit-shell();
	}

	.g-block-title-slant-tag__row {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.g-block-title-slant-tag__tag {
		flex-shrink: 0;
		transform: skewX(-18deg);
	}

	.g-block-title-slant-tag__tag-inner {
		transform: skewX(18deg);
		padding: 6px 14px;
	}

	.g-block-title-slant-tag__text {
		line-height: 1.3;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;

		&--tag {
			font-size: 16px;
			font-weight: 700;
			font-style: italic;
			color: #fff;
		}

		&--main {
			font-size: 18px;
			font-weight: 400;
			min-width: 0;
		}

		:deep(.g-rich-text-editable__content) {
			min-height: unset;
			padding: 0;
			color: inherit;
			font-weight: inherit;
			font-style: inherit;
		}
	}

	.g-block-title-slant-tag--h5 {
		.g-block-title-slant-tag__row { gap: 0.2rem; }
		.g-block-title-slant-tag__tag-inner { padding: 0.12rem 0.28rem; }
		.g-block-title-slant-tag__text--tag { font-size: 0.32rem; }
		.g-block-title-slant-tag__text--main { font-size: 0.36rem; }
	}
</style>
